<template>
  <section class="container-onboarding-content">
    <div class="wrapper-title">
      <h3>{{ t('onboarding_name_room') }}</h3>
      <h4 class="medium">
        <AnimationTyping :text="t('onboarding_name_room_please')" />
      </h4>
    </div>
    <div class="wrapper-content-detail fadeinOnboarding">
      <input
        type="text"
        :value="form.title"
        :placeholder="t('onboarding_name_room_placeholder')"
        class="input-nickname"
        @input="handleTitle"
      />
    </div>
    <a
      class="link-dashboard fadeinOnboarding"
      @click.prevent="emit('moveDashboard')"
    >
      {{ t('skip') }}
    </a>
  </section>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import AnimationTyping from '@/components/animations/AnimationTyping.vue';
import { ISelfServiceOnboardingForm } from '@/types/components';

const { t } = useI18n();

const form = defineModel<ISelfServiceOnboardingForm>({
  required: true,
  default: () => ({}) as ISelfServiceOnboardingForm,
});

const emit = defineEmits(['moveDashboard']);

const handleTitle = (e) => {
  form.value.title = e.target.value;
};
</script>

<style scoped></style>
